(() => {
  let queued = false;
  const sizeCards = () => {
    queued = false;
    document.querySelectorAll('.ProductList').forEach(list => {
      const cards = [...list.querySelectorAll('.ssg-product-card:not(.ProductItem--horizontal)')].filter(card => card.getBoundingClientRect().width > 0);
      if (!cards.length) return;
      for (const key of ['--ssg-info-height','--ssg-title-height','--ssg-pack-height']) list.style.setProperty(key,'0px');
      const maxHeight = selector => Math.ceil(Math.max(0,...cards.map(card => card.querySelector(selector)?.getBoundingClientRect().height || 0)));
      list.style.setProperty('--ssg-title-height',maxHeight('.ProductItem__Title')+'px');
      list.style.setProperty('--ssg-pack-height',maxHeight('.ssg-pack-label')+'px');
      list.style.setProperty('--ssg-info-height',maxHeight('.ProductItem__Info')+'px');
    });
  };
  const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(sizeCards); } };
  window.addEventListener('resize',schedule);
  document.addEventListener('shopify:section:load',schedule);
  document.addEventListener('click',event => { if (event.target.closest('[data-action="change-layout"]')) schedule(); });
  new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true,characterData:true});
  document.fonts?.ready.then(schedule);
  schedule();
})();
